import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "border-b border-b-gray-300 pb-5" }
const _hoisted_2 = { class: "flex flex-col items-center" }
const _hoisted_3 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, {
    style: {"height":"calc(100vh - 80px)"},
    class: "bg-white"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { style: {"padding":"0px","height":"auto"} }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "h-12 p-4 shadow-md" }, "環境設定", -1)
        ])),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_main, { style: {"padding-block":"0px","margin-top":"20px"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "APK Version管理", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form, {
                model: _ctx.apkForm,
                rules: _ctx.apkRules,
                ref: "apkFormRef",
                "label-width": "150px",
                style: {"width":"800px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Version番号",
                    prop: "version"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.apkForm.version,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.apkForm.version) = $event)),
                        placeholder: "Version番号を入力"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "URL",
                    prop: "url"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.apkForm.url,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.apkForm.url) = $event)),
                        placeholder: "URLを入力"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "INFO",
                    prop: "info"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.apkForm.info,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apkForm.info) = $event)),
                        placeholder: "INFOを入力",
                        type: "textarea",
                        rows: 10
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "w-80",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleChangeApk(_ctx.apkFormRef)))
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("保存")
                      ])),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode(_component_el_footer, { style: {"height":"20px"} })
    ]),
    _: 1
  }))
}